/**
 * Project : workspace
 * File    : FriendlyWindow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.base

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.navigation.NavController
import androidx.navigation.NavGraph
import androidx.navigation.NavHostController
import androidx.navigation.compose.rememberNavController

open class FriendlyWindow {
    companion object {
        var navigationController : NavHostController? = null
        var navGraph : NavGraph? = null
         var instance: FriendlyWindow? = null
         /**
 * Executes the shared operation.
 *
 * @receiver TODO
 * @return The resulting friendly window.
 */
         fun shared(): FriendlyWindow {
            return if (instance != null) {
                instance as FriendlyWindow
            } else {
                instance = FriendlyWindow()
                instance as FriendlyWindow
            }
        }

    }

    @Composable
    open fun content(onNavHostReady: suspend (NavController) -> Unit) {
        val navController = rememberNavController()
        navigationController = navController
        LaunchedEffect(navController) {
            navigationController = navController
            onNavHostReady(navController)
        }
    }
}